<template>
  <v-row justify="center">
    <v-col cols="12"
           sm="8">
      <setup-tfa-form @cancelled="tfaCancelled"
                      @disabled="tfaDisabled"
                      @enabled="tfaEnabled">
      </setup-tfa-form>
    </v-col>
  </v-row>
</template>
<script>

import SetupTfaForm from "./components/SetupTfaForm";

export default {
  components: {SetupTfaForm},
  methods: {
    tfaCancelled() {
      this.$router.push({name: 'show_profile'});
    },
    tfaDisabled() {
      this.$router.push({name: 'show_profile'});
    },
    tfaEnabled() {
      this.$router.push({name: 'show_profile'});
    },
  }
}
</script>
